import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/withdrawal"

export const getWithdrawals = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createWithdrawalRequest = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const changeWithdrawalStatus = async (withdrawalId, status, data) => {
  const response = await farasod.patch(`${endpoint}/result/${withdrawalId}/${status}`, data)

  return response.data
}

export const getWithdrawalTimeline = async withdrawalId => {
  const response = await farasod.get(`${endpoint}/${withdrawalId}/timeline`)

  return response.data
}

export const updateWithdrawalProviderStatus = async (withdrawalId, data) => {
  const response = await farasod.patch(`${endpoint}/${withdrawalId}/provider-status`, data)

  return response.data
}
